module.exports = __webpack_public_path__ + "static/media/a2.80b503b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sangwenfeng/a2.mp3
// module id = 8oiv
// module chunks = 0